import { A11yModule } from '@angular/cdk/a11y';
import { Component, input, output } from '@angular/core';
import { NetworkPreviewComponent } from '../../../../network/network-preview.component';

@Component({
  selector: 'app-uc2-network-blade',
  imports: [A11yModule, NetworkPreviewComponent],
  templateUrl: './uc2-network-blade.component.html',
  styleUrl: './uc2-network-blade.component.scss',
})
export class Uc2NetworkBladeComponent {
  open = input<boolean>(false);
  wellCode = input<string | null>(null);
  assetCodes = input<string[]>([]);

  closed = output<void>();

  onClose(): void {
    if (this.open()) {
      this.closed.emit();
    }
  }
}